module.exports = __webpack_public_path__ + "img/s3-2.fe67cf8f.png";